import { render, staticRenderFns } from "./OwlMobileSelectPage.vue?vue&type=template&id=6b9a9228&scoped=true"
import script from "./OwlMobileSelectPage.vue?vue&type=script&lang=js"
export * from "./OwlMobileSelectPage.vue?vue&type=script&lang=js"
import style0 from "./OwlMobileSelectPage.vue?vue&type=style&index=0&id=6b9a9228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9a9228",
  null
  
)

export default component.exports